import { LevelingEmbed } from '@/types/leveling'
import { isNumber } from '@/utils/validation'
import { treeNode } from 'data'
import { PassiveNode } from 'embed/nodes'
import React from 'react'
import Store from 'store'
import { getByLevel } from '.'
import { WithStore, useEmbed } from '../../common'

export function LevelingAscendancy({
  embed,
  stores,
  level
}: {
  embed: LevelingEmbed
  stores: Record<string, Store>
  level: number
}) {
  const ascendancyStep = React.useMemo(
    () => getByLevel(embed.steps, 'ascendancy', level, false),
    [embed.steps, level]
  )
  const activeAscendancy = useEmbed(stores, ascendancyStep?.ref, 'ascendancy')

  return activeAscendancy ? (
    <div title="Ascendancy" className="poe-ascendancy-container">
      <WithStore store={activeAscendancy.store}>
        <span className="poe-title">Ascendancy</span>

        <ul>
          {[0].map(() => {
            const step =
              activeAscendancy.embed.steps[
                activeAscendancy.active ??
                  activeAscendancy.embed.steps.length - 1
              ]
            const notables = step
              .filter(isNumber)
              .filter((id) => treeNode(id)?.is_notable)
            return notables.map((id, index) => (
              <li key={index}>
                <PassiveNode id={id} text={treeNode(id)!.name} />
              </li>
            ))
          })}
        </ul>
      </WithStore>
    </div>
  ) : null
}
